import { Routes } from "@angular/router";
import dayjs from "dayjs";

export const plannerRoutes: Routes = [
  {
    path: "planner",
    children: [
      {
        path: "",
        redirectTo: dayjs().startOf("week").add(1, "day").format("YYYY-MM-DD"),
        pathMatch: "full",
      },
      {
        path: ":date",
        loadComponent: () =>
          import("./planner-page/planner-page.component").then((m) =>
            m.PlannerPageComponent
          ),
      },
    ],
  },
  {
    path: "plan/:planId",
    loadComponent: () =>
      import("./plan-page/plan-page.component").then((m) =>
        m.PlanPageComponent
      ),
  },
];
